import { useMediaQuery } from "@mui/material";

/**
 * レポートページのステッパー（全何ページ中今どこにいるか）画像
 */
export function ReportPageStepper({
  version,
  stepName,
}: {
  version: string;
  stepName:
    | "ComprehensiveEvaluation" // 総合評価 Top.tsx
    | "SleepCondition" // 睡眠の状態 SleepCondition.tsx
    | "DaytimeCondition" // 日中の状態 DaytimeCondition.tsx
    | "SleepDisorder" // 睡眠疾患 SleepDisorder.tsx
    | "PointsOfImprovement"; // 改善アクション PointsOfImprovement.tsx
}) {
  const isSmallScreen = useMediaQuery("(max-width: 576px)");
  const [majorVersion] = version.split(".").map(Number);
  let folderName;
  let imageNumberMapping;
  let maxStepNumber;
  if (2 <= majorVersion) {
    // ver.2.0 以上はレポートが5ページまである
    folderName = isSmallScreen ? "2.0/small" : "2.0/large";
    imageNumberMapping = {
      ComprehensiveEvaluation: 1,
      SleepCondition: 2,
      DaytimeCondition: 3,
      SleepDisorder: 4,
      PointsOfImprovement: 5,
    };
    maxStepNumber = 5;
  } else {
    // ver.2.0 未満はレポートが4ページまである
    folderName = "1.0";
    imageNumberMapping = {
      ComprehensiveEvaluation: 1,
      SleepCondition: 2,
      DaytimeCondition: 3,
      PointsOfImprovement: 4,
    };
    maxStepNumber = 4;
  }
  const imageNumber = imageNumberMapping[stepName];
  const imageNumberString = imageNumber?.toString().padStart(2, "0");

  return (
    <img
      src={`/img/report/${folderName}/image_report_stepper_${imageNumberString}.svg`}
      alt={`Step ${imageNumber} / ${maxStepNumber}`}
      loading="lazy"
      style={{ width: "100%", height: "auto" }}
    />
  );
}
